{
  "spinner": {
    "status": "Searching for options..."
  },
  "buttons": {
    "delete": "Delete",
    "done": "Done",
    "next": "Next",
    "continue": "Continue",
    "back": "Back",
    "send": "Send",
    "choose": "Choose",
    "apply": "Apply",
    "sendFeedback": "Send feedback",
    "clearThanks": "Thank you, everything is clear.",
    "sendRequest": "Send request",
    "save": "Save",
    "review": "Review",
    "change": "Change",
    "cancel": "Cancel",
    "reject": "Reject",
    "approve": "Approve",
    "confirm": "Confirm",
    "view": "View",
    "download": "Download",
    "upload": "Upload",
    "copyOrder": "Copy order",
    "createOrder": "Create order",
    "edit": "Edit"
  },
  "navbar": {
    "sidebar": {
      "linkTitels": {
        "createOrder": "Create",
        "myOrders": "My orders",
        "mySuggestions": "My proposals",
        "addressBook": "Address book",
        "profile": "Profile",
        "support": "Support",
        "toggleMenu": "Collapse menu",
        "uploadingFiles": "Uploading files",
        "exchangeRates": "Exchange rates",
        "notifications": "Notifications",
        "adminPanel": "Admin panel",
        "registerUser": "Register user",
        "more": "More"
      }
    },
    "topNavBar": {
      "user": "User profile",
      "authUser": {
        "registeredAs": "Registered as",
        "account": "Account",
        "help": "Help",
        "signOut": "SignOut"
      },
      "notAuthUser": {
        "authorization": "Authorization",
        "registration": "Registration"
      }
    }
  },
  "elements": {
    "search": "Search",
    "cost": "Cost",
    "costTotal": "Total cost",
    "total": "Total",
    "noData": "No data",
    "byRequest": "Custom quote"
  },
  "notFound": {
    "title": "The page was not found"
  },
  "notSelected": {
    "title": "Not selected"
  },
  "measurementUnits": {
    "cm": "cm",
    "kg": "kg",
    "m": "m",
    "ldm": "ldm",
    "unit_one": "{{count}} unit",
    "unit_other": "{{count}} units"
  },
  "dimensions": {
    "quantity": "Quantity",
    "length": "Length*",
    "width": "Width*",
    "height": "Height*",
    "weight": "Weight*",
    "totalNumber": "Total Number",
    "volume": "Volume",
    "totalWeight": "Total Weight",
    "bulkWeight": "Bulk weight",
    "ldmWeight": "LDM weight"
  },
  "contactInfo": {
    "contactPersonLbl": "Contact person",
    "noteLbl": "Note",
    "eMail": "E-mail",
    "additionally": "Додатково",
    "payer": "Payer",
    "selectPayer": "Select a payer",
    "vatId": "VAT ID",
    "edrpou": "EDRPOU"
  },
  "dateTime": {
    "untilTime": "until {{time}}",
    "afterTime": "after {{time}}",
    "nonWorking": "non-working days"
  },
  "alerts": {
    "WrongMaxWeight": "Wrong max weight",
    "WrongCargoSize": "Wrong cargo size"
  },
  "tables": {
    "numberOfRows": "Number of rows",
    "totalResults": "{{min}}-{{max}} from {{totalCount}}",
    "noData": "No data"
  },
  "companyStatuses": {
    "underReview": "Under review",
    "verified": "Verified"
  },
  "exchangeRates": {
    "title": "Exchange Rates",
    "refresh": "Refresh",
    "rateDate": "Rate date",
    "currency": "Currency",
    "rate": "Rate",
    "source": "Source",
    "lastModified": "Last modified",
    "actions": "Actions",
    "manual": "Manual",
    "editRate": "Edit Exchange Rate",
    "editHint": "Enter the new exchange rate value",
    "resetToAuto": "Reset to auto",
    "error": "Failed to load exchange rates"
  },
  "footer": {
    "copyright": "© {{year}} Vega",
    "developedBy": "Developed by",
    "company": "Company",
    "apiIntegrations": "API & Integrations",
    "privacyPolicy": "Privacy Policy",
    "termsConditions": "Terms & Conditions",
    "news": "News"
  }
}